import React from 'react';

export const Logo = () => {
  return (
    <a href={window.HOME_PAGE} className={`logo ${window.THEME}`}>
      <img src={`/images/${window.THEME}-logo.svg`} alt={window.THEME} />
    </a>
  );
};
